/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ForbiddenPage from './forbidden.component';
import { withRouter } from 'react-router-dom';
import { selectTenantAndSetCookie, logOutAndCleanSession, updateSponsorSelection } from '../../../actions/actions';
import { createSelector } from 'reselect';
import { uniqWith } from 'ramda';

export const getSortedSponsors = createSelector(
  (state) => state,
  (state) => {
    let allocations = state.login.user && state.login.user.allocations;
    if (!allocations) return [];

    let selectedSponsorType = state.sponsor.selectedSponsor ? state.sponsor.selectedSponsor.type : 'PRODUCTION';

    let result = uniqWith(({ databasename: a }, { databasename: b }) => a === b, allocations)
      .filter((allocation) => allocation.type === selectedSponsorType)
      .sort((a, b) => a.databasename.localeCompare(b.databasename));

    return result && result.length !== 0 ? result : allocations;
  }
);

export const mapStateToProps = (state) => {
  return {
    user: state.login.user,
    error: state.login.error || state.roles.error,
    selectedSponsor: state.sponsor.selectedSponsor,
    selectSponsorError: state.sponsor.selectSponsorError,
    productionTenantForUAT: state.subject.productionTenantForUAT,
    updatedSponsor: state.sponsor.updatedSponsor,
    sponsors: getSortedSponsors(state),
    userAllocationsError: state.sponsor.userAllocationsError,
    logoutUrl: state.login.clientConfiguration.SSOLogoutUrl
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  const { history } = ownProps;
  return {
    selectTenantAndSetCookie: (sponsor) => {
      dispatch(selectTenantAndSetCookie(sponsor, history));
    },
    signOut: (SSOLogoutUrl) => {
      dispatch(logOutAndCleanSession(SSOLogoutUrl));
    },
    updateSponsorSelection: (e) => {
      if (e.target.value !== '') {
        let sponsor = JSON.parse(e.target.value);
        dispatch(updateSponsorSelection(sponsor));
      }
    }
  };
};

const ForbiddenPageContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(ForbiddenPage));

export default ForbiddenPageContainer;
